import { Link } from "react-router-dom";
import { ScheduleConsultButton } from "./ScheduleConsultButton";

type Props = {
  compact?: boolean;
};

/** Customer-facing CTA aligned with train_model2-1 portal messaging. */
export function TrainModelPromo({ compact }: Props) {
  return (
    <aside className={`train-promo${compact ? " train-promo--compact" : ""}`}>
      <p className="train-promo-eyebrow">Your data, your model</p>
      <h2 className="train-promo-title">Convert Your Data into AI Models</h2>
      {!compact && (
        <p className="train-promo-lead">
          Upload your sales and inventory history, train a model on your products and locations, then
          run forecasts like the examples in the menu — the same workflow we use in our training
          portal.
        </p>
      )}
      <ol className="train-promo-steps">
        <li>Share your use case and data securely</li>
        <li>We train and validate on your catalog</li>
        <li>Deploy to production with support</li>
      </ol>
      <div className="train-promo-actions">
        <Link className="btn btn-primary" to="/ai-models/train">
          Convert Your Data into AI Models
        </Link>
        <ScheduleConsultButton />
      </div>
    </aside>
  );
}
